module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-tra-cuu"
  }, [_c('span', {
    staticClass: "ml-3"
  }, [_vm._v("Kế hoạch điều động tàu ngày " + _vm._s(_vm.searchTopTauAll))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "margin": "8px 8px 0px 10px"
    }
  }, [_vm._v("\n      Ngày: \n    ")]), _vm._v(" "), _c('v-menu', {
    ref: "menuTopTau",
    staticStyle: {
      "margin-top": "8px"
    },
    style: ({}),
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.menuTopTauAll),
      callback: function($$v) {
        _vm.menuTopTauAll = $$v
      },
      expression: "menuTopTauAll"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0 my-0",
    attrs: {
      "slot": "activator",
      "persistent-hint": ""
    },
    slot: "activator",
    model: {
      value: (_vm.searchTopTauAll),
      callback: function($$v) {
        _vm.searchTopTauAll = $$v
      },
      expression: "searchTopTauAll"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": ""
    },
    on: {
      "input": function($event) {
        _vm.menuTopTauAll = false
      }
    },
    model: {
      value: (_vm.dateSearchTopTauAll),
      callback: function($$v) {
        _vm.dateSearchTopTauAll = $$v
      },
      expression: "dateSearchTopTauAll"
    }
  })], 1), _vm._v(" "), _c('v-icon', {
    staticStyle: {
      "margin-left": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "size": "17"
    },
    on: {
      "click": function($event) {
        _vm.menuTopTauAll = !_vm.menuTopTauAll
      }
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('v-switch', {
    staticClass: "ml-4 mt-2",
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": _vm.changeTypePart
    },
    model: {
      value: (_vm.switch1),
      callback: function($$v) {
        _vm.switch1 = $$v
      },
      expression: "switch1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "caption-header mt-3"
  }, [_vm._v("\n    Kế hoạch tàu đến cảng\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [(_vm.loadingTableTauDen) ? _c('content-placeholders', [_c('content-placeholders-img'), _vm._v(" "), _c('content-placeholders-heading')], 1) : _c('v-data-table', {
    staticClass: "table-bordered danhSachHoSoTable__class",
    attrs: {
      "headers": _vm.headersTauDenCang,
      "items": _vm.itemsDsTauDenCang,
      "hide-actions": "",
      "no-data-text": 'Không tìm thấy hồ sơ ',
      "no-results-text": 'Không tìm thấy hồ sơ '
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', {
          staticStyle: {
            "background": "#316BB6",
            "color": "#ffff"
          }
        }, _vm._l((props.headers), function(header) {
          return _c('th', {
            staticStyle: {
              "color": "#ffff !important",
              "font-weight": "normal !important"
            },
            domProps: {
              "innerHTML": _vm._s(header.text)
            }
          })
        }))]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-center",
          staticStyle: {
            "width": "2%"
          }
        }, [_vm._v("\n          " + _vm._s(props.index + 1) + "\n        ")]), _vm._v(" "), _vm._l((_vm.headersTauDenCang), function(itemKey, index) {
          return (itemKey.id !== 'stt') ? _c('td', {
            staticClass: "text-xs-center"
          }, [(itemKey.id === 'chanelCodeList') ? _c('span', _vm._l((props.item[itemKey.display]), function(item, index) {
            return _c('div', {
              key: 'chanelCodeList' + index
            }, [_vm._v(_vm._s(item))])
          })) : (itemKey.id === 'pilotNames') ? _c('span', [_c('div', {
            domProps: {
              "innerHTML": _vm._s(props.item[itemKey.display])
            }
          })]) : (itemKey.id === 'tugBoatNames') ? _c('span', [_c('div', {
            domProps: {
              "innerHTML": _vm._s(props.item[itemKey.display])
            }
          })]) : _c('span', [_vm._v(_vm._s(props.item[itemKey.display]))])]) : _vm._e()
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "caption-header mt-3 mb-3"
  }, [_vm._v("\n    Kế hoạch tàu rời cảng\n  ")]), _vm._v(" "), (_vm.loadingTableTauRoi) ? _c('content-placeholders', [_c('content-placeholders-img'), _vm._v(" "), _c('content-placeholders-heading')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-data-table', {
    staticClass: "table-bordered danhSachHoSoTable__class",
    attrs: {
      "headers": _vm.headersTauRoiCang,
      "items": _vm.itemsDsTauRoiCang,
      "hide-actions": "",
      "no-data-text": 'Không tìm thấy hồ sơ ',
      "no-results-text": 'Không tìm thấy hồ sơ '
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', {
          staticStyle: {
            "background": "#316BB6",
            "color": "#ffff"
          }
        }, _vm._l((props.headers), function(header) {
          return _c('th', {
            staticStyle: {
              "color": "#ffff !important",
              "font-weight": "normal !important"
            },
            domProps: {
              "innerHTML": _vm._s(header.text)
            }
          })
        }))]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-center",
          staticStyle: {
            "width": "2%"
          }
        }, [_vm._v("\n          " + _vm._s(props.index + 1) + "\n        ")]), _vm._v(" "), _vm._l((_vm.headersTauRoiCang), function(itemKey, index) {
          return (itemKey.id !== 'stt') ? _c('td', {
            staticClass: "text-xs-center"
          }, [(itemKey.id === 'chanelCodeList') ? _c('span', _vm._l((props.item[itemKey.display]), function(item, index) {
            return _c('div', {
              key: 'chanelCodeList' + index
            }, [_vm._v(_vm._s(item))])
          })) : (itemKey.id === 'pilotNames') ? _c('span', [_c('div', {
            domProps: {
              "innerHTML": _vm._s(props.item[itemKey.display])
            }
          })]) : (itemKey.id === 'tugBoatNames') ? _c('span', [_c('div', {
            domProps: {
              "innerHTML": _vm._s(props.item[itemKey.display])
            }
          })]) : _c('span', [_vm._v(_vm._s(props.item[itemKey.display]))])]) : _vm._e()
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "caption-header mt-3 mb-3"
  }, [_vm._v("\n    Kế hoạch tàu di chuyển\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [(_vm.loadingTableTauDiChuyen) ? _c('content-placeholders', [_c('content-placeholders-img'), _vm._v(" "), _c('content-placeholders-heading')], 1) : _c('v-data-table', {
    staticClass: "table-bordered danhSachHoSoTable__class",
    attrs: {
      "headers": _vm.headersTauDiChuyen,
      "items": _vm.itemsDsTauDiChuyen,
      "hide-actions": "",
      "no-data-text": 'Không tìm thấy hồ sơ ',
      "no-results-text": 'Không tìm thấy hồ sơ '
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', {
          staticStyle: {
            "background": "#316BB6"
          }
        }, _vm._l((props.headers), function(header) {
          return _c('th', {
            staticStyle: {
              "color": "#ffff !important",
              "font-weight": "normal !important"
            },
            domProps: {
              "innerHTML": _vm._s(header.text)
            }
          })
        }))]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-center",
          staticStyle: {
            "width": "2%"
          }
        }, [_vm._v("\n          " + _vm._s(props.index + 1) + "\n        ")]), _vm._v(" "), _vm._l((_vm.headersTauDiChuyen), function(itemKey, index) {
          return (itemKey.id !== 'stt') ? _c('td', {
            staticClass: "text-xs-center"
          }, [(itemKey.id === 'chanelCodeList') ? _c('span', _vm._l((props.item[itemKey.display]), function(item, index) {
            return _c('div', {
              key: 'chanelCodeList' + index
            }, [_vm._v(_vm._s(item))])
          })) : (itemKey.id === 'pilotNames') ? _c('span', [_c('div', {
            domProps: {
              "innerHTML": _vm._s(props.item[itemKey.display])
            }
          })]) : (itemKey.id === 'tugBoatNames') ? _c('span', [_c('div', {
            domProps: {
              "innerHTML": _vm._s(props.item[itemKey.display])
            }
          })]) : _c('span', [_vm._v(_vm._s(props.item[itemKey.display]))])]) : _vm._e()
        })]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bd08523"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KeHoachDieuDongTau.vue
// module id = 719
// module chunks = 1